import api from "./client";
import type { PeriodDays } from "./dashboard";

export interface BookingSourcePoint {
  channel: string;
  channel_key: string;
  bookings: number;
  revenue: number;
}

export interface RevenueByServicePoint {
  service_name: string;
  bookings: number;
  revenue: number;
}

export interface BookingsByDayPoint {
  day: string;
  bookings: number;
}

export interface SourcePerformancePoint {
  channel: string;
  channel_key: string;
  conversations: number | null;
  bookings: number;
  revenue: number;
  conversion_rate: number | null;
}

export interface ConversationSentimentPoint {
  sentiment: "positive" | "neutral" | "mixed" | "negative" | "not_analysed";
  label: string;
  count: number;
}

export interface ServiceInterestPoint {
  service_id: string | null;
  service_name: string;
  enquiries: number;
  bookings: number | null;
  conversion_rate: number | null;
  revenue: number | null;
  missed_enquiries: number;
  is_unknown_service: boolean;
}

export interface MissedOpportunitiesSummary {
  count: number;
  estimated_revenue: number | null;
  estimated_revenue_label: string;
}

export interface AnalyticsReports {
  period_days: PeriodDays;
  currency: string;
  booking_sources: BookingSourcePoint[];
  revenue_by_service: RevenueByServicePoint[];
  bookings_by_day: BookingsByDayPoint[];
  source_performance?: SourcePerformancePoint[];
  conversation_sentiment?: ConversationSentimentPoint[];
  service_interest?: ServiceInterestPoint[];
  missed_opportunities?: MissedOpportunitiesSummary;
}

export async function fetchAnalyticsReports(periodDays: PeriodDays): Promise<AnalyticsReports> {
  const res = await api.get<AnalyticsReports>("/analytics/reports", {
    params: { period_days: periodDays },
  });
  return res.data;
}
